import { showModal } from '@/components/Common/Modal';
import DownloadList from '@/components/DownloadList';
import UploadFile from '@/components/UploadFile';
import { RootState } from '@/index';
import { actionSendSocketData } from '@/redux/action';
import { getRandom } from '@/utils';
import { CLSTAG } from '@/utils/constant';
import { clstagStr } from '@/utils/util';
import { Modal, Popover } from 'antd';
import React, { useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
type TerminalProps = {
  disabled: boolean;
  vehicleName: string;
  userName: string;
  terminalList?:
    | {
        status: number;
        terminalName: string;
      }[]
    | null;
  getTerminalList?: AnyFunc;
  notifyCarEndDownload?: AnyFunc;
};
const TerminalClstag: any = {
  compute: clstagStr(CLSTAG.ComputeBtn),
  control: clstagStr(CLSTAG.ControlBtn),
};
const WebTerminalBtn = (props: TerminalProps) => {
  const dispatch = useDispatch();
  const { downloadList } = useSelector((state: RootState) => state.response);
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const requestIdRef = useRef<string>(
    Date.now().toString().concat(getRandom(1000, 9999).toString())
  );
  const { disabled, vehicleName, userName, getTerminalList, terminalList } =
    props;
  const [visible, setVisible] = useState<boolean>(false);
  const [clicked, setClicked] = useState<boolean>(false);
  const targetTerminalName = useRef<string>('');

  const handleClick = (data: any) => {
    if (data.status == 0) {
      return;
    }
    const url = `/app/webterminal?username=${userName}&vehiclename=${vehicleName}&terminal=${data.terminalName}`;
    window.open(url, '_blank');
  };

  const notifyCarEndDownload = ({
    fileName,
    getUrl,
  }: {
    fileName: string;
    getUrl: string;
  }) => {
    const requestData: any = {
      eventType: 'WEB_TERMINAL_COMMAND_DATA',
      data: {
        messageType: 'SERVER_TO_VEHICLE_FILE',
        header: {
          vehicleName: vehicleName,
          requestId: requestIdRef.current, //会话有效期内requestId值相同
          requestTime: Date.now(),
          needResponse: true,
          expireMilliSecond: 0,
          terminalName: targetTerminalName.current,
        },
        data: {
          fileName,
          getUrl,
        },
      },
    };
    props.notifyCarEndDownload &&
      props.notifyCarEndDownload(JSON.stringify(requestData));
    dispatch(actionSendSocketData(JSON.stringify(requestData)));
  };
  const handleUpload = (terminalName: string) => {
    showModal({
      title: terminalName + '节点：上传文件至车端',
      footer: null,
      width: 400,
      style: {
        top: '300px',
      },
      content: (
        <UploadFile
          method="PUT"
          max={'100M'}
          maxCount={1000}
          vehicleName={vehicleName}
          onSuccessCallbak={notifyCarEndDownload}
        />
      ),
    });
  };

  const getDownloadList = async () => {
    const requestData = {
      eventType: 'WEB_TERMINAL_COMMAND_DATA',
      data: {
        messageType: 'VEHICLE_TO_SERVER_FILE',
        header: {
          vehicleName,
          requestId: requestIdRef.current,
          requestTime: Date.now(),
          needResponse: true,
          expireMilliSecond: 0,
          terminalName: targetTerminalName.current,
        },
      },
    };
    dispatch(actionSendSocketData(JSON.stringify(requestData)));
    props.notifyCarEndDownload &&
      props.notifyCarEndDownload(JSON.stringify(requestData));
    setModalVisible(true);
  };

  const popContent = () => {
    return (
      <div className="terminal-list">
        {Array.isArray(terminalList) &&
          terminalList.map((item: any, index: number) => {
            return (
              <div
                key={item.terminalName}
                className={`terminal-item ${
                  item.status == 0 ? 'disabled' : 'enable-node'
                }`}
                id={'control-node_' + index}
              >
                <div
                  className={`${
                    item.status == 0 ? 'disable-node' : 'enable-node'
                  }`}
                  onClick={handleClick.bind(null, item)}
                >
                  {item.terminalName}
                </div>
                <ul className="control-node">
                  <li
                    onClick={() => {
                      targetTerminalName.current = item.terminalName;
                      getDownloadList();
                    }}
                  >
                    文件拉取
                  </li>
                  <li
                    onClick={() => {
                      targetTerminalName.current = item.terminalName;
                      handleUpload(item.terminalName);
                    }}
                  >
                    文件上传
                  </li>
                </ul>
              </div>
            );
          })}
      </div>
    );
  };
  const handleVisibleChange = (newVisible: boolean) => {
    setClicked(!clicked);
    setVisible(newVisible);
    if (newVisible) {
      getTerminalList && getTerminalList();
    }
  };

  if (disabled) {
    return (
      <li className="item terminal">
        <div className="img_gray" />

        <h3 className="operate_key">远程工具</h3>
      </li>
    );
  }

  return (
    <>
      <Popover
        content={popContent}
        trigger="click"
        open={visible}
        onOpenChange={handleVisibleChange}
      >
        <li className="item terminal">
          {!disabled ? (
            <div className="img_normal" />
          ) : (
            <div className="img_gray" />
          )}
          <h3 className="operate_key">远程工具</h3>
        </li>
      </Popover>
      <Modal
        visible={modalVisible}
        style={{ top: '300px' }}
        title={targetTerminalName.current + '节点：文件下载'}
        footer={null}
        onCancel={() => {
          setModalVisible(false);
        }}
      >
        <DownloadList downloadList={downloadList} />
      </Modal>
    </>
  );
};

export default React.memo(WebTerminalBtn);
